"use client";

import { CalendlyPopup } from "@yardzen/components/calendly-popup";
import { appendCalendlyUtm, isCalendlyUrl } from "@yardzen/js-util";
import { Button } from "@yardzen/ui/components/button";
import {
  ContentCard,
  contentCardActionClassName,
} from "@yardzen/ui/components/content-card";
import { Link } from "@yardzen/ui/components/link";
import type { ContentCardTone } from "@yardzen/ui/components/content-card";
import Image from "next/image";
import { useState } from "react";
import { MarkdownText } from "./MarkdownText";
import type { ModuleCardFields } from "./moduleCardFields";

/**
 * A card inside a MultiModuleContainer. A Calendly CTA opens the scheduling
 * modal instead of leaving the page.
 */
export function ModuleCard({
  fields: { heading, body, image, cta },
  tone,
}: {
  fields: ModuleCardFields;
  tone?: ContentCardTone;
}) {
  const [calendlyOpen, setCalendlyOpen] = useState(false);

  return (
    <ContentCard
      tone={tone}
      media={
        image && (
          <Image
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
            className="h-16 w-auto rounded-full object-cover"
          />
        )
      }
      title={heading}
      description={
        body && (
          <div className="[&_a]:relative [&_a]:z-10">
            <MarkdownText>{body}</MarkdownText>
          </div>
        )
      }
      action={
        cta &&
        (isCalendlyUrl(cta.url) ? (
          <>
            <Button
              className={contentCardActionClassName}
              onClick={() => setCalendlyOpen(true)}
            >
              {cta.text}
            </Button>
            {calendlyOpen && (
              <CalendlyPopup
                url={appendCalendlyUtm(
                  cta.url,
                  "Module Card",
                  window.location.href,
                )}
                open={calendlyOpen}
                setOpen={setCalendlyOpen}
              />
            )}
          </>
        ) : (
          <Button asChild>
            <Link className={contentCardActionClassName} href={cta.url}>
              {cta.text}
            </Link>
          </Button>
        ))
      }
    />
  );
}
